import script from "./AppCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./AppCheckbox.vue?vue&type=style&index=0&id=5844c8e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5844c8e6"]])

export default __exports__